const getRemBase = () => {
	return parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export default getRemBase;
